import Disclosure from "../../components/Disclosure/Disclosure";

const faqs = [
  {
    question: "What are the benefits of custom software?",
    answer: (
      <p>
        You have <strong>full ownership</strong>. We create a proprietary app,
        written to industry standards, and in modern, popular frameworks. You
        gain the technical ability to customize, evolve, and scale with your
        business, <strong>tailor-made</strong> to your workflows and unique
        organizational challenges.
      </p>
    ),
  },
  {
    question: "What is your development process like?",
    answer: (
      <p>
        We do our most important work before writing a line of code, by
        carefully planning each user interaction to design the most efficient
        user interface and data structure for your current needs and for the
        future. We prefer <strong>Feature-Driven Development.</strong> We
        believe in flexible, iterative workflows organized around the features
        driving your user's experience.
      </p>
    ),
  },
  {
    question: "What technologies do you specialize in?",
    answer: (
      <ul>
        <li>
          <strong>TypeScript</strong>, <strong>React</strong>, <strong>Vite</strong>,{" "}
          <strong>Vue</strong>, <strong>Tailwind CSS</strong>, and <strong>Node</strong>
        </li>
        <li>
          <strong>React Native</strong> and <strong>Expo</strong>
        </li>
        <li>
          <strong>Sanity CMS</strong>
        </li>
        <li>
          <strong>PostgreSQL</strong>, <strong>Redis</strong>, <strong>MongoDB</strong>, and{" "}
          <strong>Supabase</strong>
        </li>
        <li>
          <strong>REST</strong> and <strong>GraphQL APIs</strong>
        </li>
        <li>
          <strong>AWS</strong>, <strong>Vercel</strong>, <strong>Docker</strong>, and{" "}
          <strong>GitHub Actions</strong>
        </li>
        <li>
          <strong>Stripe</strong> and <strong>Salesforce</strong>
        </li>
        <li>
          <strong>AI tools and integrations</strong>
        </li>
      </ul>
    ),
  },
  {
    question: "How big is your company?",
    answer: (
      <p>
        We are <strong>a core team of two</strong>, which means your project
        will always receive our focused attention. We partner with{" "}
        <strong>
          a trusted network of designers, developers, copywriters, and brand
          specialists
        </strong>{" "}
        who share our commitment to excellent work, and who join us on a
        project-by-project basis depending on the scope and needs of the
        project.
      </p>
    ),
  },
  {
    question: "How do you handle maintenance and support?",
    answer: (
      <p>
        We respond to all issues within <strong>two business days</strong>{" "}
        (sooner for any urgent issues) and will fix any errors related to the
        original project scope free of charge. For ongoing maintenance,
        support, and additional features, we offer maintenance packages in
        20-hour blocks.
      </p>
    ),
  },
];

function FAQs() {
  return (
    <div className="faqs shell">
      <h1>Frequently asked questions</h1>
      <div className="disclosure-list">
        {faqs.map((faq, index) => (
          <Disclosure key={faq.question} title={faq.question} defaultOpen={index === 0}>
            {faq.answer}
          </Disclosure>
        ))}
      </div>
    </div>
  );
}

export default FAQs;
